import React from 'react'
import { NavLink } from 'react-router-dom'

import { ReactComponent as Dashboard } from 'assets/icons/dashboard.svg'
import { ReactComponent as Profile } from 'assets/icons/profile.svg'
import { ReactComponent as People } from 'assets/icons/people.svg'
import { ReactComponent as Client } from 'assets/icons/client.svg'
import { ReactComponent as Order } from 'assets/icons/shipping.svg'
import { ReactComponent as Dollar } from 'assets/icons/dollar.svg'
import { ReactComponent as Bell } from 'assets/icons/bell.svg'
import { ReactComponent as Shop } from 'assets/icons/shop.svg'
import { ReactComponent as Category } from 'assets/icons/project.svg'
import { ReactComponent as Notification } from 'assets/icons/notification.svg'

import '../styles/Menu.scss'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'AppReducer'

const Menu: React.FC = () => {
  const { logged: user } = useSelector((state: ApplicationState) => state.userReducer)
  const isAdmin = !!user?.roles?.find(role => role === 'ROLE_ADMIN' || role === 'ROLE_SUPER_ADMIN')

  const menu = [
    // { icon: Dashboard, to: '/panel/dashboard', label: 'Relatórios' },
    { icon: Profile, to: '/panel/profile', label: 'Meus Perfil' },
    { icon: Shop, to: '/panel/partner', label: 'Parceiros' },
    // { icon: Client, to: '/panel/client', label: 'Clientes' },
    // { icon: Order, to: '/panel/order', label: 'Pedidos' },
    // { icon: Dollar, to: '/panel/balance', label: 'Financeiro' },
    { icon: Bell, to: '/panel/notification', label: 'Notificações' }
  ]

  const adminMenu = [
    { icon: People, to: '/panel/user', label: 'Gestão de Usuários' },
    { icon: Category, to: '/panel/category', label: 'Categorias' },
    { icon: Notification, to: '/panel/order/status', label: 'Status de Pedido' }
  ]

  return (
    <>
      <ul className="menu">
        {
          menu.map((item, i) => {
            const Icon = item.icon
            return (
              <li key={i}>
                <NavLink exact to={item.to} className="row padding-16" activeClassName="active">
                  <Icon width={35} height={20} /> {item.label}
                </NavLink>
              </li>
            )
          })
        }
      </ul>

      {
        isAdmin &&
        <ul className="menu margin-top-64">
          <li>
            <span className="row padding-6 header" style={{ borderColor: 'transparent' }}>
              <i className="fa fa-shield"/> Administração
            </span>
          </li>
          {
            adminMenu.map((item, i) => {
              const Icon = item.icon
              return (
                <li key={i}>
                  <NavLink to={item.to} className="row padding-16" activeClassName="active">
                    <Icon width={35} height={20} /> {item.label}
                  </NavLink>
                </li>
              )
            })
          }
        </ul>
      }
    </>
  )
}

export default Menu
